/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import defaultImage from "../../../src/Assets/fallbackimg_giftcard.png";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { onGetOrder } from "../../Store/Slices/orderSlice";
import BackSections from "../Giftcards/BackSections";
import {
  onGetMail,
  onPostSendMail,
  onPostSendMailReset,
} from "../../Store/Slices/sendMailSlice";
import {
  decryptAES,
  encryptAES,
  encryptURLParam,
} from "../../Common/Axios/encrypt";
import { onGenerateTokenSubmitReset } from "../../Store/Slices/generateTokenSlice";
import axiosIntegration from "../../Common/Axios/axiosIntegration";
import { toast, ToastContainer } from "react-toastify";
import Loader from "../../Components/Loader/Loader";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import {
  ApiRespCode,
  ClientConfigurationData,
  Dispatch,
  dynamicSuccessEmailColumnChnages,
  GenerateToken,
  getImageUrl,
  LoginV3Data,
  OrderData,
  SendMail,
  SendSms,
  trackEvent,
  V3Data,
} from "../Utility/Utility";
import {
  handleGenerateToken,
  handleSendSms,
} from "../OrderUtility/OrderUitlity";
import { onPostSendSmsReset } from "../../Store/Slices/sendSmsSlice";
import { onSaveDenoCard } from "../../Store/Slices/cardDataSlice";
import BackToTopButton from "../BackToTopButton/BackToTopButton";
import { onProductByProductIdSubmit } from "../../Store/Slices/productSlice";

const RetrieveCode = () => {
  const [orderData, setOrderData] = useState({
    products: [],
    orders: [],
  });
  const navigate = useNavigate();
  const dispatch = Dispatch();
  const userOrderData = OrderData();
  const v3Data = V3Data();
  const translation = getTranslationData();
  const generateToken = GenerateToken();
  const v3LoginData = LoginV3Data();
  const sendMailData = SendMail();
  const sendSms = SendSms();
  const isLogin = sessionStorage.getItem("login");

  const loaderRef = useRef(null);
  const [hasMore, setHasMore] = useState(true);
  const [isOptEnable, setIsOptEnable] = useState();
  const [showError, setShowError] = useState(false);
  // const [showLoader, setShowLoader] = useState(false);
  const [isTriggered, setIsTriggered] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [loadingCardKey, setLoadingCardKey] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const [userOrdersList, setUserOrderList] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const clientConfig = ClientConfigurationData();
  const loginTokenData = v3LoginData?.memberProfile;
  // const [totalCount, setTotalCount] = useState(0);

  const clientConfigurationData = useSelector(
    (state) => state.clientConfigurationReducer.clientConfigurationData?.[0],
  );
  const clientProduct = useSelector(
    (state) => state.productReducer?.productById?.[0]?.products,
  );
  const clientDataReducer = useSelector((state) => state.clientDataReducer);
  const productById = useSelector((state) => state.productReducer);
  const productDataById = productById?.productByProductId?.[0];

  useEffect(() => {
    if (userOrderData?.orderData?.totalCount && userOrdersList) {
      setHasMore(userOrdersList.length < userOrderData?.orderData?.totalCount);
    }
  }, [userOrdersList]);

  useEffect(() => {
    if (!userOrderData?.isLoading && userOrderData?.orderData?.orders) {
      const orders = userOrderData?.orderData?.orders || [];
      if (pageNumber === 1) {
        setUserOrderList(orders);
      } else {
        setUserOrderList((prev) => [...(prev || []), ...orders]);
      }
    }
  }, [userOrderData, userOrderData?.isLoading]);

  useEffect(() => {
    setIsOptEnable(clientConfigurationData?.otpRedeem);
  }, [clientConfigurationData]);
  useEffect(() => {
    if (isTriggered && productById?.status_code === "200") {
      // roduct API success → now start mail flow
      handleGenerateToken(dispatch, v3Data);
    }
    if (productById?.status_code && productById?.status_code !== "200") {
      handleResendFail();
    }
  }, [productById]);

  useEffect(() => {
    // token success
    if (
      generateToken?.status_code === ApiRespCode?.v3Create &&
      isTriggered &&
      generateToken?.data?.accessToken &&
      orderData
    ) {
      axiosIntegration.defaults.headers["access-token"] =
        generateToken?.data?.accessToken;
      axiosIntegration.defaults.headers["ClientCode"] = v3Data.ClientCode;
      axiosIntegration.defaults.headers["PartnerCode"] = v3Data.partnerCode;

      sendMail(orderData, orderData.orders);
      dispatch(onGenerateTokenSubmitReset());
    }

    // TOKEN FAILED
    if (
      generateToken?.status_code &&
      generateToken?.status_code !== ApiRespCode?.v3Create &&
      isTriggered
    ) {
      handleResendFail();
      dispatch(onGenerateTokenSubmitReset());
    }

    // MAIL SUCCESS
    if (
      sendMailData?.post_status_code === ApiRespCode.v3Success &&
      isTriggered
    ) {
      dispatch(onPostSendMailReset());
      const smsTemplate = sendMailData?.getMailData?.filter(
        (item) =>
          item.enabled === true &&
          item.emailType === "Success" &&
          item.eventType === "sms",
      );
      handleSendSms(
        dispatch,
        orderData?.products,
        v3LoginData,
        v3Data,
        orderData?.products?.name,
        smsTemplate?.[0],
        orderData?.orders,
      );
    }

    // MAIL FAILED
    if (
      sendMailData?.post_status_code &&
      sendMailData?.post_status_code !== ApiRespCode.v3Success &&
      isTriggered
    ) {
      handleResendFail();
      dispatch(onPostSendMailReset());
    }

    //  SMS SUCCESS
    if (
      (sendSms?.status_code === ApiRespCode.v3Success ||
        sendSms?.status_code === "1272") &&
      isTriggered
    ) {
      dispatch(onPostSendSmsReset());

      toast.success(translation?.VoucherSuccessMessage);

      setIsTriggered(false);
      setLoadingCardKey(null);
    }

    // SMS FAILED
    if (
      sendSms?.status_code &&
      sendSms?.status_code !== ApiRespCode.v3Success &&
      sendSms?.status_code !== "1272" &&
      isTriggered
    ) {
      handleResendFail();
      dispatch(onPostSendSmsReset());
    }
  }, [generateToken, sendMailData, sendSms]);

  useEffect(() => {
    dispatch(onGetMail());
    !isLogin && setShowError(true);
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    // setShowLoader(true);
    getOrderListApiCall();
    trackEvent("page_browse", {
      page_title: "order history",
      page_url: window.location.href,
    });
  }, []);

  //use effect for infinite scroll
  useEffect(() => {
    if (pageNumber > 1) {
      getOrderListApiCall();
    }
  }, [pageNumber]);

  // IntersectionObserver for infinite scroll
  useEffect(() => {
    if (!hasMore) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setPageNumber((prev) => prev + 1);
        }
      },
      {
        root: null,
        rootMargin: "300px",
        threshold: 0.1,
      },
    );

    if (loaderRef.current) {
      observer.observe(loaderRef.current);
    }

    return () => {
      if (loaderRef.current) {
        observer.unobserve(loaderRef.current);
      }
      observer.disconnect();
    };
  }, [hasMore, userOrdersList]);

  const getOrderListApiCall = () => {
    const request = {
      memberId: v3LoginData.memberIdentifier,
      pageNumber: pageNumber,
      pageSize: 12,
    };
    dispatch(onGetOrder(request));
  };

  const cleanHTML = (htmlString) => {
    return htmlString?.replace(/\s+/g, " ")?.replace(/"/g, "'")?.trim();
  };

  const dateFormat = (dateString) => {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-GB", options)?.replace(",", "");
  };

  const replaceImportantInstruction = (htmlTemplate, importantNote) => {
    let importantIns = importantNote?.replaceAll(/"/g, "'");
    let htmlStringData = htmlTemplate;
    if (importantIns) {
      htmlStringData = htmlStringData.replace("{#removeImportantIns}", "");
      htmlStringData = htmlStringData.replace("{/removeImportantIns}", "");
      let importantInstructions = cleanHTML(importantIns);
      htmlStringData = htmlStringData.replace(
        "{%importantInstructionsList%}",
        importantInstructions,
      );
    } else {
      htmlStringData = htmlStringData.replace(
        /{#removeImportantIns}[\s\S]*?{\/removeImportantIns}/,
        "",
      );
      htmlStringData = htmlStringData.replace("{#removeImportantIns}", "");
      htmlStringData = htmlStringData.replace("{/removeImportantIns}", "");
    }
    return htmlStringData;
  };

  const replaceTermsAndConditions = (htmlTemplate, tncContent) => {
    let tncClean = tncContent?.replaceAll(/"/g, "'");
    let htmlStringData = htmlTemplate;
    if (tncContent) {
      htmlStringData = htmlStringData.replace("{#tncRemove}", "");
      htmlStringData = htmlStringData.replace("{/tncRemove}", "");
      let tnc = cleanHTML(tncClean);
      htmlStringData = htmlStringData.replace("{%tncContent%}", tnc);
    } else {
      htmlStringData = htmlStringData.replace(
        /{#tncRemove}[\s\S]*?{\/tncRemove}/,
        "",
      );
      htmlStringData = htmlStringData.replace("{#tncRemove}", "");
      htmlStringData = htmlStringData.replace("{/tncRemove}", "");
    }
    return htmlStringData;
  };

  const dynamicChildEmail = (product, templateChild, order, giftCode) => {
    if (clientDataReducer?.otpConfig === 1) {
      let dynamicChild = templateChild;
      let dynamicChildData = "";
      giftCode?.map((item) => {
        dynamicChild = dynamicSuccessEmailColumnChnages(
          dynamicChild,
          item?.CardNumber,
          item?.CardPin || item?.CardPin !== "",
        );

        dynamicChildData += dynamicChild?.replace(
          "{%voucherValue%}",
          item.Amount.split(".")[0],
          //item.Amount
        );
        dynamicChildData = dynamicChildData?.replace(
          "{%gcidValue%}",
          item?.CardNumber || "",
        );
        dynamicChildData = dynamicChildData?.replace(
          "{%vouherCodeValue%}",
          item?.CardPin,
        );
        if (!item?.CardNumber) {
          dynamicChildData = dynamicChildData?.replace(
            /{{#label}}[\s\S]*?{{\/label}}/,
            "",
          );
        } else {
          dynamicChildData = dynamicChildData
            ?.replace("{{#label}}", "")
            ?.replace("{{/label}}", "");
        }
        if (item?.CardPin === "") {
          dynamicChildData = dynamicChildData
            ?.replace("{{#pin}}", "")
            ?.replace("{{/pin}}", "");
          dynamicChildData = dynamicChildData?.replace(
            /{{#pin}}[\s\S]*?{{\/pin}}/,
            "",
          );
        }
        dynamicChildData = dynamicChildData?.replace(
          "{%expiryDate%}",
          new Date(item?.Validity).toLocaleDateString("en-GB"),
        );
      });
      return dynamicChildData;
    } else if (clientDataReducer?.otpConfig === 2) {
      let dynamicChild = templateChild;
      let dynamicChildData = "";
      dynamicChildData += dynamicChild?.replace("{%qty%}", product.qty);
      dynamicChildData = dynamicChildData?.replace(
        "{%denomination%}",
        product.denomination,
      );
      dynamicChildData = dynamicChildData?.replace(
        "{%voucherValue%}",
        Number(
          product.denomination * product.qty * (1 - product.customerDis / 100),
        ),
      );
      var enc = encryptAES(
        `email=true&orderId=${order?.orderId}?.orderId}&denomination=${product.denomination}&orderNumber=${order?.orderNumber}&mobNumber=${loginTokenData?.mobileNumber}&fName=${loginTokenData?.firstName}&lName=${loginTokenData?.lastName}`,
      );
      dynamicChildData = dynamicChildData?.replace(
        "{%retrieveCode%}",
        `${window.location.origin}/${
          clientConfig?.otpRedeem ? "otp" : "order-detail"
        }?${enc}`,
      );
      return dynamicChildData;
    }
  };

  const dynamicEmail = (htmlString, orderData, templateChild, order) => {
    let htmlStringData = htmlString;
    const giftCode = orderData?.products?.giftCode
      ? decryptAES(orderData?.products?.giftCode)
      : null;
    const hasCardPin = giftCode?.some(
      (item) => item.CardPin !== null && item.CardPin !== "",
    );
    htmlStringData = dynamicSuccessEmailColumnChnages(
      htmlStringData,
      giftCode?.[0]?.labels?.cardNumber,
      hasCardPin,
    );
    htmlStringData = htmlStringData?.replace(
      "{%gcidLabel%}",
      giftCode?.[0]?.labels?.cardNumber,
    );
    htmlStringData = htmlStringData?.replace(
      "{%voucherCodeLabel%}",
      giftCode?.[0]?.labels?.cardPin,
    );

    if (!giftCode?.[0]?.labels?.cardNumber) {
      htmlStringData = htmlStringData?.replace(
        /{{#label}}[\s\S]*?{{\/label}}/,
        "",
      );
    } else {
      htmlStringData = htmlStringData
        ?.replace("{{#label}}", "")
        ?.replace("{{/label}}", "");
    }

    if (!hasCardPin) {
      htmlStringData = htmlStringData?.replace(/{{#pin}}[\s\S]*?{{\/pin}}/, "");
    } else {
      htmlStringData = htmlStringData
        ?.replace("{{#pin}}", "")
        ?.replace("{{/pin}}", "");
    }

    htmlStringData = htmlStringData?.replace(
      "{%memberName%}",
      `${v3LoginData?.memberProfile?.firstName || ""} ${v3LoginData?.memberProfile?.lastName || ""}`.trim()
    );

    htmlStringData = htmlStringData?.replace("{%orderId%}", order?.orderId);

    const productImage =
      getImageUrl(productDataById?.small) ||
      "https://dpjvnq3sbpndh.cloudfront.net/email-images/fallbackimg_giftcard.png";

    htmlStringData = htmlStringData?.replace("{%productUrl%}", productImage);

    const productId = orderData?.products?.productId?.toString();
    const finalProductId =
      process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
        ? productId
        : encryptURLParam(productId);
    htmlStringData = htmlStringData?.replace(
      "{%redeemLink%}",
      `${window.location.origin}/tnc?productId=${finalProductId}`,
    );

    htmlStringData = htmlStringData?.replace(
      "{%voucherName%}",
      orderData?.products?.name,
    );
    // Convenience Fee + GST combined value
    if (order.convenienceFee && order.gst) {
      htmlStringData = htmlStringData
        ?.replace("{{#ifShowGST}}", "")
        ?.replace("{{/ifShowGST}}", "");
      htmlStringData = htmlStringData?.replace(
        /{{#ifShow}}[\s\S]*?{{\/ifShow}}/,
        "",
      );
      const total = (order?.convenienceFee + order?.gst).toFixed(2);
      htmlStringData = htmlStringData?.replace("{%gstConv%}", total);
    } else if (order.convenienceFee) {
      htmlStringData = htmlStringData
        ?.replace("{{#ifShow}}", "")
        ?.replace("{{/ifShow}}", "");
      htmlStringData = htmlStringData?.replace(
        /{{#ifShowGST}}[\s\S]*?{{\/ifShowGST}}/,
        "",
      );
      htmlStringData = htmlStringData?.replace(
        "{%gstConv%}",
        order?.convenienceFee?.toFixed(2),
      );
    } else {
      htmlStringData = htmlStringData?.replace(
        /{{#ifShow}}[\s\S]*?{{\/ifShow}}/,
        "",
      );
      htmlStringData = htmlStringData?.replace(
        /{{#ifShowGST}}[\s\S]*?{{\/ifShowGST}}/,
        "",
      );
    }
    htmlStringData = htmlStringData?.replace("{%cashPaid%}", order.amount);
    htmlStringData = htmlStringData?.replace("{%ptsRedeem%}", order.burnPoint);

    const totalvalue = order?.totalAmount.toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });

    htmlStringData = htmlStringData?.replace("{%totalAmt%}", totalvalue);
    htmlStringData = (htmlStringData || "").replace(
      "{%TNC%}",
      cleanHTML(orderData?.tncContent) || "",
    );
    htmlStringData = htmlStringData?.replace(
      "{%mobNo%}",
      clientConfig?.phoneNumber,
    );

    htmlStringData = replaceImportantInstruction(
      htmlStringData,
      productDataById?.instructionsContent,
    );
    htmlStringData = replaceTermsAndConditions(
      htmlStringData,
      productDataById?.tncContent,
    );

    let childData = dynamicChildEmail(
      orderData,
      templateChild,
      order,
      giftCode,
    );

    htmlStringData = htmlStringData?.replace("{%child%}", childData);
    return htmlStringData;
  };

  const fetchEmailTemplate = async (data, product, order) => {
    let template = cleanHTML(data?.mailBody);
    let templateChild = cleanHTML(data?.mailBodyChild);
    template = dynamicEmail(template, product, templateChild, order);
    return template;
  };

  const replacePlaceholders = (template, replacements) => {
    return template?.replace(/{{(.*?)}}/g, (_, key) => replacements[key]);
  };

  const sendMail = async (product, order) => {
    const enabledSuccessMails = sendMailData?.getMailData?.filter(
      (item) =>
        item.enabled === true &&
        item.emailType === "Success" &&
        item.eventType === "email",
    );
    let subject = enabledSuccessMails?.[0]?.subject;
    subject = subject?.replace("{%voucherName%}", product?.products?.name);
    const template = await fetchEmailTemplate(
      enabledSuccessMails?.[0],
      product,
      order,
    );
    const htmlContent = replacePlaceholders(template, {});
    const mailPayload = {
      toEmailId: v3LoginData?.memberProfile?.emailId,
      templateCode: enabledSuccessMails?.[0]?.tempCode,
      content: htmlContent,
      subject: subject,
      contentValue: {
        UserName: "",
      },
    };
    await sendMailUser(mailPayload);
  };

  const sendMailUser = async (payload) => {
    try {
      dispatch(onPostSendMail(payload));
    } catch (error) {
      console.error("Error calling switch account API:", error);
      throw error;
    }
  };

  function getTNCById(id, type = "tncContent") {
    const item = clientProduct?.find((entry) => entry.sku === id);
    return item ? item[type] : null;
  }

  //  If resend API fails
  const handleResendFail = () => {
    toast.error(translation?.UnableToResendTheCode);
    setIsTriggered(false);
    setLoadingCardKey(null);
  };

  const handleRetrieveCode = (productData, order, cardKey, actionType) => {
    dispatch(onSaveDenoCard({ productData, orderId: order.orderId }));
    setOrderData({ products: productData, orders: order });

    if (clientDataReducer?.otpConfig === 1) {
      // GET CODE (existing behavior)
      if (actionType === "GET") {
        isOptEnable
          ? navigate("/otp", {
              state: {
                orderId: order?.orderId,
                denomination: productData?.denomination,
              },
            })
          : navigate("/order-detail", {
              state: {
                orderId: order?.orderId,
                denomination: productData?.denomination,
              },
            });
      }

      // RESEND CODE → GENERATE TOKEN
      if (actionType === "RESEND") {
        setLoadingCardKey(cardKey);
        setIsTriggered(true);
        dispatch(onPostSendMailReset());
        dispatch(onPostSendSmsReset());
        dispatch(onGenerateTokenSubmitReset());
        dispatch(onProductByProductIdSubmit(productData?.productId));
      }
    } else if (clientDataReducer?.otpConfig === 2) {
      setLoadingCardKey(cardKey);
      if (loadingCardKey === null) {
        setLoadingCardKey(cardKey);
        setIsTriggered(true);
      } else {
        toast.error(translation?.CompleteFirstOrder);
        return;
      }
      handleGenerateToken(dispatch, v3Data);
    }

    trackEvent("coupon_redeem", {
      currency: "INR",
      value: order?.amount, // amount actually paid
      discount:
        order?.products?.reduce((sum, item) => {
          const discountAmount =
            (item.denomination * (item.customerDis || 0)) / 100;
          return sum + discountAmount;
        }, 0) || 0,
      gift_card_value: order.products?.reduce(
        (sum, item) => sum + item.denomination * item.qty,
        0,
      ),
      items: order.products?.map((item) => ({
        id: order?.id,
        item_id: item?.sku,
        item_name: item?.name,
        item_brand: item?.name,
        item_category: "Gift Card",
        affiliation: "IDFC Store",
        item_category2: order?.category,
        item_image: item?.image,
        item_url: window.location.href,
        price: Math.floor(item?.denomination * (1 - item?.customerDis / 100)),
        quantity: item?.qty,
        gift_card_points: item?.denomination,
        expiry_date: order?.expireDate,
      })),
    });
  };

  const handleLogin = () => {
    window.open(v3Data?.SignInUrl, "_self");
  };
  const handleClick = () => {
    const prevRoute = sessionStorage.getItem("PREV_ROUTE");

    if (prevRoute === "/order-confirmation" || prevRoute === "/order-detail") {
      navigate("/", { replace: true }); // Home
    } else {
      navigate(-1);
    }
  };

  return (
    <>
      <ToastContainer />
      <BackToTopButton />
      {/* <ScrollToTop /> */}
      {showError ? (
        handleLogin()
      ) : (
        <>
          {(userOrderData.isLoading || isProcessing) && pageNumber === 1 ? (
            <Loader />
          ) : (
            <div className="bg">
              <BackSections />
              {clientDataReducer?.otpConfig === 2 && isMobile ? (
                <div class="order-bottom trend-mb m-3">
                  {translation?.detailsSentRegistered}
                  <div className="mt-1">{translation?.mobileEmail}</div>
                </div>
              ) : (
                <>
                  <section className="mt-4 m-2">
                    <div className="container p-2">
                      <div className="row justify-content-center">
                        <div className="gift-head">
                          <h2>
                            <span
                              onClick={handleClick}
                              className="showDesktopOnly changeCursor"
                            >
                              <i className="fa-solid fa-chevron-left clr-black-blk"></i>{" "}
                              &nbsp;
                            </span>
                            {translation?.orders}
                          </h2>
                        </div>
                        <div className="col-12">
                          <div className="bg-pink1">
                            <div class="messg">
                              {translation?.detailsSentRegisteredContact}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </>
              )}
              <section className="m-2">
                <div className="container p-2">
                  <div className="row justify-content-center">
                    <div
                      className={`orders-container featured-gap ${
                        isMobile ? "mobile-cards" : "desktop-cards"
                      }`}
                    >
                      {userOrderData?.orderData &&
                        Array.isArray(userOrdersList) &&
                        [...userOrdersList].map((order, orderIndex) =>
                          order?.products?.map((product, index) => (
                            <div
                              className={`order-card ${
                                clientDataReducer?.otpConfig === 2 &&
                                "height-310"
                              }`}
                              key={`${orderIndex}-${index}`}
                            >
                              <div className="card-content pb-4">
                                <span className="order-image">
                                  <img
                                    src={getImageUrl(product.image)}
                                    alt={product.name}
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src = defaultImage;
                                    }}
                                  />
                                </span>
                                <div className="order-details">
                                  <h3 className="order-heading">{`${product.name} ₹ ${product.denomination} e-Gift-Card`}</h3>
                                  <div className="mt-2">
                                    <div className="order-info">
                                      <span className="order-info1">
                                        <p>{translation?.orderAmount}</p>
                                        <span>
                                          {order.totalBurn > 0 &&
                                            `${order.totalBurn} Pts + `}
                                          ₹{order.amount}
                                        </span>
                                      </span>
                                      <span className="order-info1">
                                        <p>{translation?.quantity}</p>
                                        <span>{product.qty}</span>
                                      </span>
                                    </div>
                                    <div className="order-info">
                                      <span className="order-info1">
                                        <p>{translation?.orderNumber}</p>
                                        <span>{order.orderId}</span>
                                      </span>
                                      <span className="order-info1">
                                        <p>{translation?.orderDate}</p>
                                        <span>
                                          {order.createdOn
                                            ? dateFormat(order.createdOn)
                                            : "Invalid Date"}
                                        </span>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {order?.orderStatus === "Pending" ||
                              order?.orderStatus.toLowerCase() ===
                                "Cancelled".toLowerCase() ||
                              order?.orderStatus.toLowerCase() ===
                                "failed".toLowerCase() ? (
                                <button className="expired" disabled>
                                  {/* {translation?.expired} */}
                                  {order?.orderStatus}
                                </button>
                              ) : (
                                <>
                                  {clientDataReducer?.otpConfig === 1 && (
                                    <div className="order-card-footer">
                                      <div className="btn-row right-align">
                                        {/* GET CODE */}
                                        <button
                                          className={`code-btn get-btn ${
                                            loadingCardKey ===
                                            `${orderIndex}-${index}-get`
                                              ? "loading"
                                              : ""
                                          }`}
                                          onClick={() =>
                                            handleRetrieveCode(
                                              product,
                                              order,
                                              `${orderIndex}-${index}-get`,
                                              "GET",
                                            )
                                          }
                                        >
                                          {loadingCardKey ===
                                          `${orderIndex}-${index}-get` ? (
                                            <span className="spinner-border spinner-border-sm"></span>
                                          ) : (
                                            translation?.retrieveCode
                                          )}
                                        </button>

                                        {/* RESEND CODE */}
                                        <button
                                          className={`code-btn resend-btn ${
                                            loadingCardKey ===
                                            `${orderIndex}-${index}-resend`
                                              ? "loading"
                                              : ""
                                          }`}
                                          onClick={() =>
                                            handleRetrieveCode(
                                              product,
                                              order,
                                              `${orderIndex}-${index}-resend`,
                                              "RESEND",
                                            )
                                          }
                                        >
                                          {loadingCardKey ===
                                          `${orderIndex}-${index}-resend` ? (
                                            <span className="spinner-border spinner-border-sm"></span>
                                          ) : (
                                            translation?.resendCode
                                          )}
                                        </button>
                                      </div>
                                    </div>
                                  )}

                                  {clientDataReducer?.otpConfig === 2 && (
                                    <button
                                      className={`retrieve-btn resend-btn ${
                                        loadingCardKey ===
                                        `${orderIndex}-${index}-resend`
                                          ? "loading"
                                          : ""
                                      }`}
                                      onClick={() =>
                                        handleRetrieveCode(
                                          product,
                                          order,
                                          `${orderIndex}-${index}-resend`,
                                          "RESEND",
                                        )
                                      }
                                    >
                                      {loadingCardKey ===
                                      `${orderIndex}-${index}-resend` ? (
                                        <span className="spinner-border spinner-border-sm"></span>
                                      ) : (
                                        translation?.resendCode
                                      )}
                                    </button>
                                  )}
                                </>
                              )}
                            </div>
                          )),
                        )}
                    </div>
                  </div>
                </div>
              </section>
              {/* Loader/Observer element for infinite scroll */}
              {hasMore &&
                Array.isArray(userOrdersList) &&
                userOrdersList.length > 0 && (
                  <div
                    ref={loaderRef}
                    className="col-12 text-center py-4"
                    style={{ minHeight: "50px" }}
                  ></div>
                )}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default RetrieveCode;
